/** Company events endpoints (/api/company-events/*) — popup feed + CRUD + push broadcast. */
import type { ApiResponse, CompanyEventDto, CompanyEventPushLogDto, CompanyEventTarget, CompanyEventUpsertInput } from '@system/shared'
import { apiFetch } from './api-client-core'

const JSON_HEADERS = { 'Content-Type': 'application/json' }

export function getActiveCompanyEvents(): Promise<ApiResponse<CompanyEventDto[]>> {
  return apiFetch('/api/company-events/active')
}

export function listCompanyEvents(): Promise<ApiResponse<CompanyEventDto[]>> {
  return apiFetch('/api/company-events')
}

export function createCompanyEvent(input: CompanyEventUpsertInput): Promise<ApiResponse<CompanyEventDto>> {
  return apiFetch('/api/company-events', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(input) })
}

export function updateCompanyEvent(id: string, input: CompanyEventUpsertInput): Promise<ApiResponse<CompanyEventDto>> {
  return apiFetch(`/api/company-events/${id}`, { method: 'PATCH', headers: JSON_HEADERS, body: JSON.stringify(input) })
}

export function deleteCompanyEvent(id: string): Promise<ApiResponse<{ ok: boolean }>> {
  return apiFetch(`/api/company-events/${id}`, { method: 'DELETE' })
}

export function pushCompanyEvent(id: string): Promise<ApiResponse<{ sent: number }>> {
  return apiFetch(`/api/company-events/${id}/push`, { method: 'POST' })
}

export function getCompanyEventTargets(): Promise<ApiResponse<CompanyEventTarget[]>> {
  return apiFetch('/api/company-events/targets')
}

export function getCompanyEventPushLogs(): Promise<ApiResponse<CompanyEventPushLogDto[]>> {
  return apiFetch('/api/company-events/push-logs')
}
